import { connect } from 'react-redux';
import {
    actions
} from '../../../../../redux/modules/Series/Series';
import SeriesUsuarios from './SeriesUsuarios';

const mstp = state => {
    return {...state.bodegas, permisos: state.login.me.permisos}
};
const mdtp = {
    ...actions
};

export default connect(mstp, mdtp)(SeriesUsuarios)